module.exports = __webpack_public_path__ + "img/logos.10108a16.png";